<ng-container *ngIf="options$ | async as options">
  <p *ngIf="showTitle" class="specialty-dropdown__title" [ngClass]="{'bold': boldTitle}">{{title ?? 'Specialty'}}
    <span *ngIf="isRequired" class="error">(Required)</span>
  </p>
    <lib-autocomplete
      [defaultOption]="defaultOption"
      [disabled]="disabled"
      [dividerIndex]="userSpecialties?.length"
      [error]="error"
      [name]="name"
      [fullWidth]="fullWidth"
      [isInvalid]="isInvalid"
      [options]="options"
      [placeholder]="placeholder"
      [trackingIdPrefix]="trackingIdPrefix + '_specialty'"
      (optionSelected)="handleSelection($event)"
    ></lib-autocomplete>
</ng-container>
